import { createReducer, on, Action } from '@ngrx/store';
import { rgbColorActionTypes } from './rgb-color.actions';
import {
    rgbColorAdapter,
    RGBColorState
} from './rgb-color.entity';

import * as _ from 'lodash';
import { authActionTypes } from './../../../auth/store/auth.actions';

export const initialState: RGBColorState = rgbColorAdapter.getInitialState({
    ids: [],
    entities: null,
    total: 0,
    loaded: false
});

export const rgbColorReducerObj = createReducer(
    initialState,

    on(rgbColorActionTypes.setRGBColors, (state, action) => {
        return rgbColorAdapter.addAll(action.rgbColors, { ...state, loaded: action.rgbColors.length > 0, total: action.rgbColors.length })
    }),

    on(rgbColorActionTypes.add, (state, action) => {
        return rgbColorAdapter.addOne(action.color, { ...state, total: state.total + 1 })
    }),

    on(rgbColorActionTypes.deleteRGB, (state, action) => {
        return rgbColorAdapter.removeOne(action.id, { ...state, total: state.total - 1 })
    }),

    on(authActionTypes.LogOut, (state, action) => {
        return rgbColorAdapter.removeAll(state)
    }),

    on(rgbColorActionTypes.clear, (state, action) => {
        return rgbColorAdapter.removeAll(state)
    })
);

export function rgbColorReducer(state: RGBColorState = initialState, action: Action): RGBColorState {
    return rgbColorReducerObj(state, action);
}

export const rgbColorSelectors = rgbColorAdapter.getSelectors();
